import styled from 'styled-components';

const Saved = styled.div`
  width: 100%;
  margin-top: 20px;
  color: white;
  background: #4caf50;
  padding: 10px;
  border-radius: 5px;
  font-size: 15px;
`;

export default Saved;
